import { ColumnsType } from "antd/es/table";
import { t } from "i18next";
import { ExciseWarehouse } from "./exciseWarehouse.types";

export const getExciseWarehouseTableColumns = () => {
  return [
    { title: t("TABLES.OZNAKA_SKLADISTA"), dataIndex: "oznakaSkladista" },
    {
      title: t("TABLES.BROJ_AKTIVNOG_RESENJA"),
      dataIndex: "brojAktivnogResenja",
    },
    { title: t("TABLES.TIP_RESENJA"), dataIndex: "tipResenja" },
    {
      title: t("TABLES.DATUM_DO_KADA_VAZI_RESENJE"),
      dataIndex: "datumVazenjaResenja",
    },
    {
      title: t("TABLES.DATUM_RESENJA"),
      dataIndex: "datumIzdavanjaResenja",
    },
  ] as ColumnsType<ExciseWarehouse>;
};
